export const TEST_ID = 'mapVerticalControlBar';
